import type { CSSProperties, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LiftEmailProps {
    email: string
    className?: string
}

/**
 * The studio email set large. On hover its underline draws across and each letter lifts 2px in
 * turn (see .lift-email in globals.css).
 */
export const LiftEmail: FC<LiftEmailProps> = ({ email, className }): ReactNode => {
    return (
        <a href={`mailto:${email}`} className={cn('lift-email relative inline-block pb-2 text-ink', className)}>
            <span className='sr-only'>
                {email}
            </span>

            <span aria-hidden='true'>
                {email.split('').map((letter, index) => (
                    <span key={index} className='lift-letter' style={{ '--i': index } as CSSProperties}>
                        {letter}
                    </span>
                ))}
            </span>

            <span className='absolute inset-x-0 bottom-0 h-px bg-hairline' aria-hidden='true' />
            <span className='lift-underline absolute inset-x-0 bottom-0 h-px bg-ink' aria-hidden='true' />
        </a>
    )
}
